import React from 'react'
import AddEventTimeslot from './AddEventTimeslot'

class TimeslotEventAddTab extends React.Component {
  state = {
    language_data: [],
  }

  componentDidMount() {
    if (
      this.props.match.params.event_id !== undefined &&
      this.props.match.params.event_id !== null &&
      this.props.match.params.event_id !== 0 &&
      this.props.match.params.event_id !== ''
    ) {
      this.setState({ event_id: this.props.match.params.event_id })
      this.setState({ eventTimeslot_id: this.props.match.params.eventTimeslot_id })
    }
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>
                      {this.props.match.params.eventTimeslot_id ? 'Edit' : 'Add'} Event Timeslot{' '}
                      {!this.props.match.params.eventTimeslot_id && (
                        <span style={{ color: 'red' }}>(You can create only 100 days slots at once)</span>
                      )}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        id={'Event_add_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.event_id !== undefined &&
                        this.state.event_id !== null &&
                        this.state.event_id !== 0 &&
                        this.state.event_id !== '' ? (
                          <AddEventTimeslot
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            event_id={this.props.match.params.event_id}
                            eventTimeslot_id={this.props.match.params.eventTimeslot_id}
                          />
                        ) : (
                          <AddEventTimeslot
                            language_id={this.state.language_id}
                            goBack={this.props.history.goBack}
                            event_id={this.props.match.params.event_id}
                            eventTimeslot_id={this.props.match.params.eventTimeslot_id}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TimeslotEventAddTab
